import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { remove, isEmpty } from 'lodash'
import { Style } from './styles'
import { IMG } from '../../themes'


export class MultiSelect extends PureComponent {
  static propsType = {
    list: PropTypes.array.isRequired,
    onFocus: PropTypes.func,
    value: PropTypes.string,
    onChange: PropTypes.func,
    callBackResult: PropTypes.func.isRequired,
  }

  state = {
    isFocus: false,
    tagList: [],
    selectList: [],
    list: [],
    value: '',
  }

  componentDidMount () {
    const { listEdit } = this.props

    this.setState({
      selectList: listEdit,
    })
  }

  componentDidUpdate (prevProps, prevState) {
    const { value, list, callBackResult } = this.props
    const { selectList } = this.state

    if (value !== prevProps.value) {
      this.setState({
        value,
      })
    }
    if (list !== prevProps.list) {
      this.setState({
        list,
      })
    }
    if (selectList !== prevState.selectList) {
      callBackResult(selectList)
    }

  }

  _onSelectList = item => {
    const { selectList } = this.state

    console.log({
      isFocus: false,
      selectList: [
        ...selectList,
        { ...item },
      ],
      value: '',
    })

    this.setState({
      isFocus: false,
      selectList: [
        ...selectList,
        { ...item },
      ],
      value: '',
    })
  }

  _onFocus = () => {
    const { onFocus } = this.props

    this.setState({
      isFocus: true,
    }, () => {
      onFocus()
    })
  }

  _onCloseTag = index => {
    const { tagList } = this.state

    tagList.splice(index, 1)
    this._onFocus()
  }

  _onCloseList = index => {
    const { selectList } = this.state
    const { onFocus } = this.props

    selectList.splice(index, 1)
    this.setState({
      isFocus: false,
    }, () => {
      onFocus()
    })
  }

  _onKeyUp = event => {
    const { tagList, list, value, selectList } = this.state

    if (!value.substring(0, 1).match(/^\s/) && !value.substring(0, 1).match(/^[,]/)) {

      // space and comma
      if (event.which === 32 || event.keyCode === 32 || event.which === 188 || event.keyCode === 188) {
        if (!value.substring(0, 1).match(/^\s/)) {
          this.setState({
            tagList: [
              ...tagList,
              {
                username: value.replace(/,/g, ''),
              },
            ],
            value: '',
          })
        }
      }

      // enter
      if (event.which === 13 || event.keyCode === 13) {
        if (!isEmpty(value)) {
          this.setState({
            selectList: [
              ...selectList,
              ...tagList,
              { username: value.replace(/,/g, '') },
            ],
            tagList: [],
            value: '',
            isFocus: false,
          })
        } else {
          this.setState({
            selectList: [
              ...selectList,
              ...tagList,
            ],
            tagList: [],
            value: '',
            isFocus: false,
          })
        }
      }

      // backspace
      if ((event.which === 8 || event.keyCode === 8)) {
        if (tagList.length > 0) {
          this.setState({
            list: [
              ...list,
              tagList[tagList.length - 1],
            ],
          }, () => this._onFocus())
        }
        // remove last tagList
        tagList.pop()
      }
    }
  }

  render () {
    const {
      onChange = () => { },
      disabled
    } = this.props
    const { isFocus, tagList, list, value, selectList } = this.state

    remove(list, item => selectList.filter(ele => ele.username === item.username)[0])

    return (
      <Style>
        <div className='multi-area'>
          <div className='multi-container'>
            {tagList && tagList.map((item, index) => (
              <div
                key={`${item.username}_${index}`}
                className='multi-box'
              >
                {item.username}
                <div
                  onClick={() => this._onCloseTag(index)}
                  className='close'>X</div>
              </div>
            ))
            }
            <input
              className='multi-input'
              value={value.replace(/[^a-z0-9@._-\d,\s]+/g, '')}
              onChange={onChange}
              onFocus={this._onFocus}
              onKeyUp={this._onKeyUp}
              disabled={disabled}
            />
            <img
              className={isFocus ? 'icon-cancel-dropdown' : 'icon-cancel'}
              src={IMG[isFocus ? 'ic_cancel_text.svg' : 'ic_search_dropdown.svg']}
              alt='sort'
              onClick={() => this.setState({ isFocus: false, value: '' })}
            />
          </div>
        </div>
        {isFocus && (
          <div className='multi-result'>
            {list.map(item => (
              <div
                onClick={() => this._onSelectList(item)}
                key={item.username}
                className='result-list'>
                <figure>
                  <img
                    className='result-avatar-img'
                    src={item.profileThumbnail
                      ? `data:image/png;base64, ${item.profileThumbnail}`
                      : IMG['user-tie-solid.svg']
                    }
                    alt='user avatar'
                  />
                </figure>
                <div className='result-group'>
                  <h1 className='result-title'>{item.name}</h1>
                  <div className='result-description'>{item.username}</div>
                </div>
              </div>
            ))
            }
          </div>
        )
        }
        <div className='multi-select-list'>
          {selectList && selectList.map((item, index) => (
            <div
              key={`${item.username}_${index}`}
              className='select-list'>
              <figure>
                <img
                  className='result-avatar-img'
                  src={!item.profileThumbnail
                    ? IMG['user-tie-solid.svg']
                    : `data:image/png;base64, ${item.profileThumbnail}`
                  }
                  alt='user avatar'
                />
              </figure>
              <div className='result-group'>
                <h1 className='result-title'>{item.name || item.username}</h1>
                {item.name && <div className='result-description'>{item.username}</div>}
              </div>
              <button className='close-button' onClick={() => this._onCloseList(index)} disabled={disabled}>
                <svg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='times' role='img'
                  xmlns='http://www.w3.org/2000/svg' viewBox='0 0 352 512'>
                  <path fill='currentColor' d='M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z' />
                </svg>
              </button>
            </div>
          ))
          }
        </div>
      </Style>
    )
  }
}
